import { Link } from 'react-router-dom';
import BasicButton from '.';
import './BasicButton.scss';

const LinkButton = (props: {
  text: string;
  to: string;
  disabled?: boolean;
  type?: 'primary' | 'secondary' | 'warning';
  onClick?: () => void;
}) => {
  return (
    <Link to={ props.to } className="link-button-container">
      <BasicButton text={ props.text } type={ props.type ?? 'secondary' }
        disabled={ props.disabled }
        onClick={ props.onClick || (() => { }) } />
    </Link>
  );
};

export default LinkButton;
